<template>
    <div v-bind:class="'form-group '+classes">
        <label class="m-r-sm">{{ label }}</label>
        <select :id="'bool-select-'+id" v-model="value_inner">
            <option value="true">{{ t_yes }}</option>
            <option value="false">{{ t_no }}</option>
        </select>
    </div>
</template>

<script>
    export default {
        props: ['id', 'label', 'default', 'classes', 'yes', 'no'],
        data: function() {
            return {
                value_inner: this.default
            }
        },
        watch: {
            value_inner: function(val, oldVal){
                this.$emit('onChange', this.id, val === 'true');
            }
        },
        computed: {
            t_yes: function() {
                if(typeof this.yes === 'undefined') {
                    return Lang.langGet("Yes");
                } else {
                    return this.yes;
                }
            },
            t_no: function() {
                if(typeof this.no === 'undefined') {
                    return Lang.langGet("No");
                } else {
                    return this.no;
                }
            }
        }
    }
</script>
